import { useState } from "react";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseAddButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseAddButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzNursePrintButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton";
import OperationAreaSection from "../components/OperationAreaSection";
import OperationDetailsSection from "../components/OperationDetailSection";
import NurseConfirmationSection from "../components/NurseConfirmationSection";
import SurgerySection from "../components/SurgerySection";
import PatientDatas from "src/modules/medcard/patient-datas";
import { Box, Divider, Grid, Stack, Typography } from "@mui/material";
import ByzMuiCloseButton from "src/components/core-components/mui/buttons/ByzMuiCloseButton";
import { useNavigate } from "react-router-dom";
import { ToolType } from "../canvaComponent/canvas/type/types";
import DrawingToolbar, { FillPattern, LineStyle } from "../canvaComponent/canvas/DrawingToolbar";
import { Shape } from "../canvaComponent/canvas/KovaCanvas";
//import DrawingList from '../canvaComponent/DrawingList';

export default function SafetySurgeryFormCreate() {
    const [shapes, setShapes] = useState<Shape[]>([]);
    const [tool, setTool] = useState<ToolType>("pen");
    const [strokeColor, setStrokeColor] = useState("#000000");
    const [fillColor, setFillColor] = useState("transparent");
    const [lineStyle, setLineStyle] = useState<LineStyle>("solid");
    const [lineWidth, setLineWidth] = useState(2);
    const [fillPattern, setFillPattern] = useState<FillPattern>("solid");
    const [selectedShapeId, setSelectedShapeId] = useState<string | null>(null);
    const navigate = useNavigate();

    return (
        <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', height: '100vh' }}>
            {/* Sayfa Başlığı */}
            <Typography variant="h5" gutterBottom>
                Güvenli Cerrahi Formu
            </Typography>
            <Box sx={{ mb: 2 }}>
                <PatientDatas isOpenMedCard={true} isCreateMedCard={true} />
            </Box>
            <Box sx={{ mt: 4 }} />
            {/* Üst Butonlar */}
            <Stack direction="row" spacing={2} sx={{ mb: 1, justifyContent: "space-between", alignItems: "center" }}>
                <Stack direction="row" spacing={2}>
                    <ByzNurseSaveButton onClick={() => {
                      console.log("Güncel Çizim Verisi:", shapes);
                    }} />
                    <ByzNurseAddButton />
                    <ByzNurseDeleteButton />
                    <ByzNursePrintButton />
                </Stack>
                <ByzMuiCloseButton onClick={() => {
                    navigate("/nurse/patient-list");
                    window.location.reload(); 
                }} />
            </Stack>

            <Divider sx={{ my: 1 }} />

            {/* Çizim Araç Çubuğu */}
            <DrawingToolbar
                currentTool={tool}
                onChangeTool={setTool}
                onChangeStrokeColor={setStrokeColor}
                onChangeFillColor={setFillColor}
                onChangeLineStyle={setLineStyle}
                onChangeLineWidth={setLineWidth}
                onChangePattern={setFillPattern}
                onUndo={() => setShapes(prev => prev.slice(0, -1))}
                lineStyle={lineStyle}
                lineWidth={lineWidth}
                fillPattern={fillPattern}
            />

            <Grid container spacing={2} alignItems="stretch" sx={{ flex: 1}}>
                {/* Sol Alan */}
                <Grid item xs={12} md={6}>
                    <Stack spacing={2} sx={{ height: '100%' }}>
                        <OperationAreaSection />
                        <OperationDetailsSection />
                        <NurseConfirmationSection />
                    </Stack>
                </Grid>

                {/* Sağ Alan */}
                <Grid item xs={12} md={6} sx={{ height: '100%', minWidth: 0 }}>
                    <Box sx={{ height: '100%' }}>
{/* Cannot convert a Symbol value to a string hatasını atlamak için SurgerySection componentini yorum satırı yapın formu açtığınızda yorum satırındna kaldırın */}
                        <SurgerySection
                            shapes={shapes}
                            setShapes={setShapes}
                            tool={tool}
                            strokeColor={strokeColor}         
                            fillColor={fillColor}
                            lineStyle={lineStyle}
                            lineWidth={lineWidth}
                            fillPattern={fillPattern}
                        /> 
                    </Box>
                </Grid>
            </Grid>

            {/* Çizim kutucukları alanı - çizim alanından bağımsız */}
            {/* <DrawingList
                shapes={shapes}
                setShapes={setShapes}
                selectedShapeId={selectedShapeId}
                setSelectedShapeId={setSelectedShapeId}
            /> */}
        </Box>
    );
}